import { dataAttributeSolid } from 'dls-icons-data'
import { createIcon } from '../common'

const IconAttributeSolid = /*#__PURE__*/createIcon(dataAttributeSolid)
export default IconAttributeSolid
